import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./close.svg"; export default path + "#$"